var map = {
	"./icon_1.svg": "80ff",
	"./icon_10.svg": "5b65",
	"./icon_2.svg": "5bd1",
	"./icon_3.svg": "e375",
	"./icon_4.svg": "7b52",
	"./icon_5.svg": "4637",
	"./icon_6.svg": "f460",
	"./icon_7.svg": "39fc",
	"./icon_8.svg": "ebc5",
	"./icon_9.svg": "1cdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e20";